import React from "react";
import { AreaChart, Area, CartesianGrid, XAxis, YAxis, Label, ResponsiveContainer, Tooltip } from "recharts";
import { parseISO, format } from "date-fns";
import Title from "./Title";

const TicketsEvolutionChart = ({ data }) => {
  const chartData = data?.map((item) => ({
    date: format(parseISO(item.date), "dd/MM"),
    count: parseInt(item.count) || 0,
  })) || [];

  return (
    <div className="w-full h-full flex flex-col">
      <Title>Evolución Diaria (Tickets)</Title>
      <div className="w-full h-64 relative">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData} margin={{ top: 16, right: 16, bottom: 0, left: -20 }}>
            <defs>
              <linearGradient id="colorEvolution" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#4f46e5" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#4f46e5" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" className="dark:stroke-slate-800" />
            <XAxis dataKey="date" stroke="#94a3b8" tick={{ fontSize: 11 }} />
            <YAxis type="number" allowDecimals={false} stroke="#94a3b8" tick={{ fontSize: 11 }} />
            <Tooltip
              contentStyle={{
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                border: "1px solid #e2e8f0",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                fontSize: "12px",
                color: "#1e293b"
              }}
              labelStyle={{ fontWeight: "bold" }}
            />
            <Area
              type="monotone"
              dataKey="count"
              stroke="#4f46e5"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorEvolution)"
              name="Tickets"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TicketsEvolutionChart;

